import queryString from "query-string";

import { init as initSimulacao } from "./simulacao";
import { fetchWrapper } from "../utils/fetchWrapper";

export const init = async () => {
    const requestParameters = queryString.parse(window.location.search);
    const rsid = requestParameters.RSID;
    const customer = requestParameters.customer;

    if (rsid) {
        await fetchWrapper(
            `/api/security/login?rsid=${rsid}&customer=${customer}`, 
            null, 
            { usingModularAuthentication: false }
        );
        window.location.replace("/");

    }
    else {
        //carrega simulação e outras telas
        await initSimulacao();
    }
}